module.exports = __webpack_public_path__ + "img/lenovo-skin.74a0f3d.webp";